export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  // { width: 40, align: 'center', fixed: 'left', type: 'checkbox' },
  {
    field: 'driveNo',
    title: '设备编号',
    fixed: 'left',
    align: 'center',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
    slots: {
      default: 'driveNo',
    },
  },
  {
    field: 'coolNo',
    title: '冷藏箱编号',
    align: 'center',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'orderNo',
    title: '订单编号',
    align: 'center',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
    slots: {
      default: 'orderNo',
    },
  },
  {
    field: 'dispatchOrderNo',
    title: '调度订单编号',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'bizBillNo',
    title: 'ERP/WMS单号',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'transportModeName',
    title: '运输模式',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'orderTypeName',
    title: '订单类型',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'bizTypeName',
    title: '业务类型',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'custName',
    title: '客户名称',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'carrierName',
    title: '承运商名称',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'driverName',
    title: '司机名称',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'vehicleNo',
    title: '车牌号',
    align: 'center',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
]
